// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"60":"e711e433","897":"61617ac5"}[chunkId] + ".js";
};